/* MOBILE re-arrangement of the product-description area (owner request):
     - the "Have a question about this product?" (Anagram) widget moves BELOW
       all the accordions (owner 2026-08-06; was above);
     - the Klaviyo review list - its own top-level #reviews section, normally
       at the bottom of the page - moves INTO the "Customer Reviews" accordion,
       right below the Customers Say summary.
   Both are put back exactly where the theme rendered them on desktop, where the
   two-column layout and the standalone reviews section stay unchanged. Driven
   off the same 749px breakpoint the accordion CSS uses.

   Safe to move these nodes: the Anagram widget lives entirely inside
   .llm-product-qa, and the Klaviyo block is populated by #id (so its DOM
   position is irrelevant) and was verified to keep its rendered reviews intact
   across a relocation. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');

  var grid = document.querySelector('.llm-product-description__grid');
  var qa = document.querySelector('.llm-product-qa');
  var reviews = document.getElementById('reviews');
  var reviewsMount = document.querySelector('.llm-cr-reviews-mount');

  // The standalone "Customer Reviews" heading is its own little section above
  // the review widget. Once the reviews move into the "Reviews -" accordion on
  // mobile, that heading is left orphaned below the accordions, so hide it there
  // (and restore on desktop). Found by its text so we don't guess at section ids.
  var reviewHeadingSection = null;
  var headings = document.querySelectorAll('.shopify-section h1, .shopify-section h2, .shopify-section h3');
  for (var i = 0; i < headings.length; i++) {
    var h = headings[i];
    if (/^\s*customer\s*reviews\s*$/i.test(h.textContent)
        && !h.closest('.llm-product-description')
        && !h.closest('#reviews')) {
      reviewHeadingSection = h.closest('.shopify-section');
      break;
    }
  }

  // Remember each node's original home (parent + the sibling it preceded) so
  // desktop can restore it precisely.
  var qaHome = qa ? { parent: qa.parentNode, next: qa.nextSibling } : null;
  var reviewsHome = reviews ? { parent: reviews.parentNode, next: reviews.nextSibling } : null;

  function toMobile() {
    if (qa && grid && qa.parentNode !== grid) {
      grid.appendChild(qa); // below the last accordion (was: above them)
    }
    if (reviews && reviewsMount && reviews.parentNode !== reviewsMount) {
      reviewsMount.appendChild(reviews);
    }
    if (reviewHeadingSection) {
      reviewHeadingSection.style.display = 'none';
    }
  }

  function toDesktop() {
    if (qa && qaHome && qa.parentNode !== qaHome.parent) {
      qaHome.parent.insertBefore(qa, qaHome.next);
    }
    if (reviews && reviewsHome && reviews.parentNode !== reviewsHome.parent) {
      reviewsHome.parent.insertBefore(reviews, reviewsHome.next);
    }
    if (reviewHeadingSection) {
      reviewHeadingSection.style.display = '';
    }
  }

  function apply() {
    if (mq.matches) toMobile();
    else toDesktop();
  }

  apply();

  // Re-evaluate when the breakpoint is crossed (resize / rotate).
  if (mq.addEventListener) {
    mq.addEventListener('change', apply);
  } else if (mq.addListener) {
    mq.addListener(apply); // older Safari
  }
})();
